import React, { useContext, useState } from "react"
import { PopupButton, PopupWrapper } from "../../../../components/styled/BasicBlocks"
import { InputText } from "../../../../components/inputText/InputText"
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuPrivacy.css";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { changePassword } from "../../../../api/api";

export const SideMenuPrivacy = ({onClose}: ISideMenuRouteProps) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [errors, setErrors] = useState<any>({});
    const [isChangeSent, setIsChangeSent] = useState(false);
    const [result, setResult] = useState('');
    const {translate} = useContext(AppContext);

    const handleSave = async ()=>{
        if (isChangeSent){
            return;
        }
        setIsChangeSent(true);
        try {
            await changePassword(oldPassword, newPassword);
            setIsChangeSent(false);
            setResult('success');
        } catch (e){
            console.log('wrong password');
            setResult('error');
        } finally {
            setIsChangeSent(false);
        }
    }

    const handleClose = ()=>{
        onClose();
    }

    return <PopupWrapper className="SideMenuPrivacy">
        <SideMenuCommonHeader text={translate('sideMenu_privacy')} onClose={handleClose}></SideMenuCommonHeader>
        <div>{translate('sideMenuPrivacy_updatePassword')}: </div>
        <div className="SideMenuPrivacy_changePasswordForm"> 
            <InputText 
                className="" 
                label={translate('sideMenuPrivacy_oldPassword')}
                value={oldPassword} 
                onChange={(e)=>{setOldPassword(e)}}
                error={errors.oldPassword}
                type="password"
            ></InputText>
            <InputText 
                className="" 
                label={translate('sideMenuPrivacy_newPassword')}
                value={newPassword} 
                onChange={(e)=>{setNewPassword(e)}}
                error={errors.newPassword}
                type="password"
            ></InputText>
            <PopupButton 
                className="SideMenuPrivacy_changePasswordButton" 
                onClick={handleSave}
            >{translate('sideMenuPrivacy_changePassword')}</PopupButton>
        </div>
        {result == 'error' && <div>
            Wrong password
        </div>}
        {result == 'success' && <div>
            Password is successfully changed
        </div>}
    </PopupWrapper>
}